import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "LoadingWrapper" }
const _hoisted_2 = { class: "LoadingContent" }
const _hoisted_3 = { class: "LoadingProgressBarWrapper" }
const _hoisted_4 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[0] || (_cache[0] = _createElementVNode("img", {
        class: "LoadingAnimation",
        src: "https://monet-prtl-co.imgix.net/Endor/ERT/loading-indicator-globe.svg",
        alt: "Loading animation"
      }, null, -1 /* CACHED */)),
      _cache[1] || (_cache[1] = _createElementVNode("span", { class: "LoadingText" }, "Loading SMT uploads", -1 /* CACHED */)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("progress", {
          class: "LoadingProgressBar",
          max: "100",
          value: _ctx.progress
        }, null, 8 /* PROPS */, _hoisted_4)
      ])
    ])
  ]))
}